import { apiClient } from "../../../Utilities/apiClient";
import { SingleRoute } from "../../../Resources/Data/Routes";

export interface RoutesListParams {
  page?: number;
  pageSize?: number;
  status?: string;
  state?: string;
  name?: string;
  sortBy?: string;
}

export interface RoutesListResponse {
  routes: SingleRoute[];
  count: number;
}

export const routeService = {
  getRoutes: (params: RoutesListParams = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.pageSize) queryParams.append('pageSize', params.pageSize.toString());
    if (params.name) queryParams.append('name', params.name);
    if (params.status) queryParams.append('status', params.status);
    if (params.state) queryParams.append('state', params.state);
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);

    return apiClient.get(`/routes?${queryParams.toString()}`);
  },

  getPendingRoutes: (params: RoutesListParams = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.pageSize) queryParams.append('pageSize', params.pageSize.toString());

    return apiClient.get(`/routes/pending?${queryParams.toString()}`);
  },

  getRoute: (id: string) =>
    apiClient.get(`/routes/${id}`),

  updateRoute: (id: string, data: Partial<SingleRoute>) =>
    apiClient.put(`/routes/${id}`, data),

  activateRoute: (id: string | number) =>
    apiClient.patch(`/routes/${id}/activate`),

  deactivateRoute: (id: string | number, rejectionReason?: string) =>
    apiClient.patch(`/routes/${id}/deactivate`, { rejectionReason }),

  deleteRoutePhoto: (routeId: string, photoKey: string) =>
    apiClient.delete(`/routes/${routeId}/photos/${photoKey}`),

  updateRoutePhotos: (id: string, formData: FormData) =>
    apiClient.put(`/routes/${id}`, formData, {
      contentType: 'multipart/form-data'
    }),
};
